export default __webpack_public_path__ + "static/media/hht1_ep3_minisitcom_01.70d7de16.png";